export default class Faq {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'validString',
    tenantID: 'validString',
    section: 'validString',
    question: 'validString',
    answer: 'validString',
  }
  */
  async createQuestion(faqObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/tenant/${this.api.config.tenantID}/faq/new`;
    req.body = faqObj;
    return await req.exec();
  }
  async updateQuestion({ id, ...faqObj }) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/tenant/${this.api.config.tenantID}/faq/${id}`;
    req.body = faqObj;
    return await req.exec();
  }
  async deleteQuestion(faqID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/tenant/${this.api.config.tenantID}/faq/${faqID}`;
    return await req.exec();
  }
  async getQuestion(faqID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/tenant/${this.api.config.tenantID}/faq/${faqID}`;
    return await req.exec();
  }
  async getAllQuestions(tenantID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/tenant/${tenantID || this.api.config.tenantID}/faqs`;
    return await req.exec();
  }
}
